module.exports = __webpack_public_path__ + "static/img/products-SealABC.282c8e89.png";